module.exports = __webpack_public_path__ + "img/nuvola_3.c71bb9ef.png";